import React from "react";
import { InputBase } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { useTranslation } from "../../../hooks/useTranslation";
import BundleKey from "../../../translation/bundleKey";
import Button from "../../common/PL/Button/Button";
import "./ExitUserInput.css";

type ExitUserInputProps = {
  onRegisterExitWithoutCheckin?: () => void;
  value?: string;
  onChange?: (value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};

const Input = ({
  onRegisterExitWithoutCheckin,
  value,
  onChange,
  onKeyDown,
}: ExitUserInputProps) => {
  const { t } = useTranslation();

  return (
    <div className="exitInputContainer">
      <div className="exitInput">
        <Search className="searchIcon" />
        <InputBase
          className="exitInputField"
          placeholder={t(BundleKey.EXITUSERINPUT_SEARCH_PLACEHOLDER)}
          inputProps={{
            "aria-label": t(BundleKey.EXITUSERINPUT_SEARCH_PLACEHOLDER),
          }}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={onKeyDown}
        />
      </div>
      <Button size="large" className="exitButton" onClick={onRegisterExitWithoutCheckin}>
        {t(BundleKey.EXITUSERINPUT_REGISTER_EXIT_WITHOUT_CHECKIN)}
      </Button>
    </div>
  );
};

export default Input;
